<template>
<v-dialog v-model="dialog" width="500">
  <v-card>
    <v-card-title>
      <span class="headline">ダウンロード</span>
    </v-card-title>
    <v-card-actions>
      <v-btn :disabled="!this.yearMonth" @click="save()">ダウンロード</v-btn>
      <v-btn @click="dialog = false">戻る</v-btn>
    </v-card-actions>
    <v-container fluid>
      <v-layout>
        <v-flex md12 sm6 xs12>
          <date-picker label="月次" type="month" v-model="yearMonth"></date-picker>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() {
    return {
      yearMonth: null,
      dialog: false
    }
  },
  methods: {
    popup() {
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save(){
      this.resolve(this.yearMonth)
      this.dialog = false
    }
  }
}
</script>

<style>

</style>
